<template>
  <div class="w100 pt20 pb20 pl20 pr20 bg-w card-shadow" v-loading="loading">
    <p class="w100 bold mb20 font-18 tx-c">服务概况（审批类服务）</p>

    <div class="w100 flex-box al-c sift-view">
      <DateComp ref="date" @change="initPage" />
      <el-button class="ml10" type="primary" size="mini" @click="initPage">查询</el-button>
    </div>

    <!-- <div class="w100 mt20 flex-box al-c">
      <div class="mr10 flex-box">
        <span style="line-height: 28px;">部门/学院：</span>
        <el-select v-model="deptcCollegeValue" size="mini" filterable placeholder="请选择" @change="initPage">
          <el-option v-for="(item, index) in deptcCollege" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <el-button type="primary" size="mini" @click="initPage">查询</el-button>
      <el-button type="warning" size="mini" @click="showSearchView">服务查询</el-button>
    </div> -->

    <div class="w100 mt20">
      <div class="w100 po-r flex-box serve-count-survey">
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #64c871;">
          <p class="font-24">{{ headCount.totalServeNum }}</p>
          <p class="font-14">服务次数</p>
        </div>
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #999845;">
          <p class="font-24">{{ headCount.queryServeNum }}</p>
          <p class="font-14">查询服务次数</p>
        </div>
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #8e3fc5;">
          <p class="font-24">{{ headCount.serveNum }}</p>
          <p class="font-14">审批服务次数</p>
        </div>
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #797979;">
          <p class="font-24">{{ headCount.endRate }}%</p>
          <p class="font-14">办结率</p>
        </div>
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #286595;">
          <p class="font-24">{{ headCount.otherServerNum }}</p>
          <p class="font-14">应用访问次数</p>
        </div>
        <!-- <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #8d2094;">
          <p class="font-24">{{ headCount.avgAppraiseScore ? headCount.avgAppraiseScore : '-' }}分</p>
          <p class="font-14">评价平均值</p>
        </div> -->
      </div>
    </div>

    <div class="w100 mt20 po-r serve-count-table">
      <el-table class="w100 tx-c my-table" :data="list" stripe border>
        <el-table-column align="center" label="序号" width="60px">
          <template slot-scope="scope">
            {{ pageNum * pageSize - pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务名称" prop="serveName"></el-table-column>
        <el-table-column align="center" label="发起次数" prop="initiateNum" width="120px"></el-table-column>
        <el-table-column align="center" label="结办率" prop="endRate" width="160px">
          <template slot-scope="scope">
            {{ scope.row.endRate }}%
          </template>
        </el-table-column>
        <el-table-column align="center" label="流程平均时长" width="150px">
          <template slot-scope="scope">
            {{ scope.row.avgTakeTime | costTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="收藏人数" prop="collectionNum" width="120px"></el-table-column>
        <el-table-column align="center" label="评分" width="120px">
          <template slot-scope="scope">
            {{ scope.row.avgAppraiseScore === null ? '-' : scope.row.avgAppraiseScore }}
          </template>
        </el-table-column>
      </el-table>
      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </div>

    <ServeDialog ref="serveDialog" />
  </div>
</template>

<script>
import DateComp from "@/components/public/DateComp";
import ServeDialog from "@/components/statistical/ServeDialog";

export default {
  name: "AllView03",
  components: {
    DateComp,
    ServeDialog
  },
  props: [],
  data() {
    return {
      loading: false,

      startDate: "",
      endDate: "",
      deptId: "",
      pageNum: 1,
      pageSize: 20,
      total: 0,
      deptcCollege: [],
      deptcCollegeValue: "",

      headCount: {
        totalServeNum: 0,
        queryServeNum: 0,
        serveNum: 0,
        otherServerNum: 0,
        endRate: 0.0
      },
      list: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    // this.feacthSiftData();
    this.fetchList();
  },
  destroyed() {},
  methods: {
    feacthSiftData() {
      this.loading = true;

      this.$http
        .post(`option/query/deptcCollege`)
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.deptcCollege = data.resData.data;
            this.$nextTick(() => {
              this.deptcCollegeValue = data.resData.value;
              this.initPage();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchList() {
      this.loading = true;

      const date = this.$refs.date.getValue();
      this.$http
        .post(
          `/statistical/all/byHall`,
          JSON.stringify({
            start: date[0],
            end: date[1],
            // deptId: this.deptcCollegeValue,
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }),
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8"
            }
          }
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.headCount.totalServeNum =
              data.resData.serveCountSurvey.totalServeNum;
            this.headCount.queryServeNum =
              data.resData.serveCountSurvey.queryServeNum;
            this.headCount.serveNum = data.resData.serveCountSurvey.serveNum;
            this.headCount.otherServerNum =
              data.resData.serveCountSurvey.otherServerNum;
            this.headCount.endRate = data.resData.serveCountSurvey.endRate;

            this.list = data.resData.countPage.list;
            this.total = data.resData.countPage.total;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    showSearchView() {
      this.$refs.serveDialog.showView();
    }
  },
  watch: {},
  filters: {
    costTimeH(value) {
      if (!value) return "-";
      const time = Math.floor(value / 1000);
      const day = Math.floor(time / (3600 * 24));
      const hour = Math.floor((time - day * 3600 * 24) / 3600);
      const min = Math.floor((time - day * 3600 * 24 - hour * 3600) / 60);
      let str = "";
      if (day > 0) {
        str += day + "天";
      }
      if (hour > 0) {
        str += hour + "时";
      }
      if (str == "") {
        str += min + "分";
      }
      return str;
    }
  }
};
</script>

<style scoped>
.survey-card {
  padding: 20px 10px;
  border-radius: 4px;
}
</style>
